export default __webpack_public_path__ + "static/media/redis.4be5948f.svg";